import React from 'react'
import styles from './PublicQuestions.module.scss'

interface TextTruncateProps {
  text: string
  wordLimit: number
  onClick: () => void
}

const TextTruncate: React.FC<TextTruncateProps> = ({ text, wordLimit, onClick }) => {
  const words = text.split(' ')
  const isLong = words.length > wordLimit
  const truncatedText = isLong ? words.slice(0, wordLimit).join(' ') + '...' : text

  return (
    <span 
      className={isLong ? styles.truncatedText : ''}
      onClick={isLong ? onClick : undefined}
      title={isLong ? 'Click to view full text' : ''}
    >
      {truncatedText}
    </span>
  )
}

export default TextTruncate